import type { ClientArticleProps } from "../../../../../../logic/SitePresenter/SitePresenter";
import type ExtensionUpdaterRules from "../ExtensionUpdaterRules";

const getArticlePropsRule = (articleProps: ClientArticleProps): ExtensionUpdaterRules => {
	const filterNames = ["selectionMenu", "copyArticles", "copyMsO", "ArticleTitleHelpers"];

	return {
		filter: (extension) => filterNames.includes(extension.name),
		options: { articleProps },
	};
};

export default getArticlePropsRule;
